import { Link } from 'react-router-dom';
import Seo from './Seo';
import './ServicePage.css';

export default function NotFound() {
  return (
    <div className="service-page service-page-notfound container">
      <Seo
        title="Sidan kunde inte hittas | Briljans"
        description="Sidan du letar efter finns inte."
        path="/404"
        noindex
      />
      <span className="service-page-eyebrow">404</span>
      <h1>Sidan kunde inte hittas</h1>
      <p className="service-page-intro">
        Sidan du letar efter finns inte längre eller har flyttat.
      </p>
      <Link to="/" className="btn-primary">Till startsidan</Link>
    </div>
  );
}
